/**
 * iBill LaunchPad - Permission Configuration
 *
 * Permission Naming: menu:submenu:action
 *
 * Usage:
 *   import { PERMISSIONS } from './config/permissions';
 *   <PermissionButton permission={PERMISSIONS.ZONE_RENEWAL_RENEW} />
 *   // or directly:
 *   <PermissionButton permission="zone:renewal:renew" />
 */

export { PERMISSIONS, getAllPermissions, getPermissionCount } from './permissionsDomainDriven';
export { default } from './permissionsDomainDriven';
